import { getAPI } from "../../../api/Networking";
import { LabelValue } from "../../../models/Dashboard/Analytics";
import { LogisticsAnalyticsAPIFilters } from "../../../models/Dashboard/LogisticsDashboard/LogisticsAnalyticsFilters";

export default class LogisticsAnalyticsDashboardAPI {
  getTatsData = async (
    url: string,
    filters: LogisticsAnalyticsAPIFilters
  ): Promise<LabelValue[]> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.start_date)
        queryParams.append("start_date", filters.start_date);

      if (filters.end_date) queryParams.append("end_date", filters.end_date);

      if (filters.inventory_type)
        queryParams.append("inventory_type", filters.inventory_type.id);

      if (filters.order_id && filters.order_id.length > 0) {
        queryParams.append(
          "order_id",
          filters.order_id.map((item) => item.id).join(",")
        );
      }

      if (filters.order_type && filters.order_type.length > 0) {
        queryParams.append(
          "order_type",
          filters.order_type.map((item) => item.id).join(",")
        );
      }

      if (filters.pm_adminids && filters.pm_adminids.length > 0) {
        queryParams.append(
          "pm_adminids",
          filters.pm_adminids.map((item) => item.id).join(",")
        );
      }

      if (filters.customer_id && filters.customer_id.length > 0) {
        queryParams.append(
          "customer_id",
          filters.customer_id.map((item) => item.id).join(",")
        );
      }

      const response = await getAPI(
        `/v5/logistics-analytics${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
